import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import MaterialCell from '@mui/material/TableCell';
const PREFIX = 'TableCell';

const classes = {
  root: `${PREFIX}-root`,
};

const StyledCell = styled(MaterialCell)({
  [`& .${classes.root}`]: {
    fontSize: 14,
  },
});

export default function TableCell({ children, ...otherProps }) {
  return <StyledCell {...otherProps}>{children}</StyledCell>;
}

TableCell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
